// import DataTable from '../../../../../components/LynDataTable/DataTable';
import * as React from 'react';
import { useEffect, useMemo, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
// import ExitButton from 'components/button/ExitButton';
// import comptroller from 'assets/images/comptroller_white.svg';
import { Dialog, DialogContent, Typography } from '@mui/material';
import { Spin } from 'antd';
import dayjs from 'dayjs';
import ViewEditModalHeader from '../../../../../components/modal/ViewEditModalHeader';
import SolutionCatalogIcon from 'assets/icons/solutions-catalog';
import LeaseDataTable from './LeaseDataTable';

const LeaseRecordViewModal = ({ showModal, setShowModal, checkResponseData = [], tableUpperLeftExtraInfo = null }) => {
	// const theme = useTheme();

	const [propcessData, setPropcessData] = useState([
		{
			date: '-',
			headCode: '-',
			debit: '-',
			credit: '-',
		},
	]);

	// function formatNumber(number, decimals = 2) {
	// 	// First, handle invalid inputs
	// 	if (typeof number !== 'number' || isNaN(number)) {
	// 		// throw new Error('Please provide a valid number');
	// 		return;
	// 	}

	// 	// Round to specified decimal places using toFixed
	// 	// but convert back to number to remove trailing zeros
	// 	const roundedNumber = Number(number.toFixed(decimals));

	// 	// Use Intl.NumberFormat for consistent formatting
	// 	const formatter = new Intl.NumberFormat('en-US', {
	// 		minimumFractionDigits: decimals,
	// 		maximumFractionDigits: decimals,
	// 	});

	// 	return formatter.format(roundedNumber);
	// }
	function formatNumber(number, decimals = 2) {
		// First, handle invalid inputs
		if (typeof number !== 'number' || isNaN(number)) {
			throw new Error('Please provide a valid number');
			// return;
		}

		// Round to specified decimal places using toFixed
		// but convert back to number to remove trailing zeros
		const roundedNumber = Number(number.toFixed(decimals));

		// Use Intl.NumberFormat for consistent formatting
		const formatter = new Intl.NumberFormat('en-US', {
			minimumFractionDigits: decimals,
			maximumFractionDigits: decimals,
		});

		return formatter.format(roundedNumber);
	}
	// useEffect(() => {
	// 	let arrayExcludeData = [];

	// 	checkResponseData
	// 		?.filter((item) => item?.group !== 'Payment')
	// 		.map((item) => {
	// 			let itemData = {
	// 				date: item?.entryDate?.dateString ? dayjs(item?.entryDate?.dateString).format('YYYY-MM-DD') : '',
	// 				head: item?.head ? item?.head : '-',
	// 				debit: !isNaN(item?.debit) && item?.debit !== null && item?.debit !== undefined ? formatNumber(item?.debit) : 0,
	// 				credit: !isNaN(item?.credit) && item?.debit !== null && item?.credit !== undefined ? formatNumber(item?.credit) : 0,
	// 			};
	// 			arrayExcludeData.push(itemData);
	// 		});
	// 	setPropcessData(arrayExcludeData);
	// }, [checkResponseData]);

	useEffect(() => {
		let arrayExcludeData = [];

		checkResponseData
			?.filter((item) => item?.group !== 'Payment')
			.map((item) => {
				let itemData = {
					date: item?.entryDate?.dateString ? dayjs(item?.entryDate?.dateString).format('YYYY-MM-DD') : '',
					head: item?.head ? item?.head : '',
					description: item?.description ? item?.description : '',
					debit: 0,
					credit: 0,
					costCenterCode: item?.costCenterCode ? item?.costCenterCode : '',
					headCode: item?.headCode ? item?.headCode : '',
				};

				try {
					if (!isNaN(item?.debit) && item?.debit !== null && item?.debit !== undefined) {
						itemData.debit = formatNumber(item?.debit);
					}
				} catch (error) {
					return null;
					// Keep default value of 0
				}

				try {
					if (!isNaN(item?.credit) && item?.credit !== null && item?.credit !== undefined) {
						itemData.credit = formatNumber(item?.credit);
					}
				} catch (error) {
					return null;

					// Keep default value of 0
				}
				arrayExcludeData.push(itemData);
				return arrayExcludeData;
			});
		setPropcessData(arrayExcludeData);
	}, [checkResponseData]);

	const checkColumnDesign = [
		{
			id: 'date',
			width: '5%',
			align: 'center',
			accessor: 'date',
			cellAlign: 'center',
			Header: 'Date',
			isVisible: true,
			Cell: (cell) => {
				return (
					<div style={{ textAlign: 'center' }}>
						<Typography>{dayjs(cell?.row?.original?.date).format('YYYY-MM-DD')}</Typography>
					</div>
				);
			},
		},
		{
			id: 'costCenterCode',
			width: '5%',
			align: 'center',
			accessor: 'costCenterCode',
			cellAlign: 'center',
			Header: 'Cost Center',
			isVisible: false,
			Cell: (cell) => {
				return (
					<div>
						<Typography align="left" sx={{ ml: 2 }}>
							{cell?.row?.original?.costCenterCode}
						</Typography>
					</div>
				);
			},
		},
		{
			id: 'headCode',
			width: '5%',
			align: 'center',
			accessor: 'headCode',
			cellAlign: 'center',
			Header: 'General Ledger',
			isVisible: false,
			Cell: (cell) => {
				return (
					<div>
						<Typography align="left" sx={{ ml: 2 }}>
							{cell?.row?.original?.headCode}
						</Typography>
					</div>
				);
			},
		},
		{
			id: 'head',
			width: '5%',
			align: 'center',
			accessor: 'head',
			cellAlign: 'center',
			Header: 'Head',
			isVisible: true,
			Cell: (cell) => {
				return (
					<div>
						<Typography align="left" sx={{ ml: 2 }}>
							{cell?.row?.original?.comment?.length > 0
								? cell?.row?.original?.head + '(' + cell?.row?.original?.comment + ')'
								: cell?.row?.original?.head}
						</Typography>
					</div>
				);
			},
		},
		{
			id: 'description',
			width: '5%',
			align: 'center',
			accessor: 'description',
			cellAlign: 'center',
			Header: 'Description',
			isVisible: true,
			Cell: (cell) => {
				return (
					<div>
						<Typography align="left" sx={{ ml: 2 }}>
							{cell?.row?.original?.description}
						</Typography>
					</div>
				);
			},
		},
		{
			id: 'debit',
			width: '5%',
			align: 'center',
			accessor: 'debit',
			cellAlign: 'center',
			Header: 'Debit',
			isVisible: true,
			Cell: (cell) => {
				return (
					<div>
						<Typography align="right" sx={{ mr: 1 }}>
							{+cell?.row?.original?.debit !== 0 ? cell?.row?.original?.debit : ''}
						</Typography>
					</div>
				);
			},
		},
		{
			id: 'credit',
			width: '5%',
			align: 'center',
			accessor: 'credit',
			cellAlign: 'center',
			Header: 'Credit',
			isVisible: true,
			Cell: (cell) => {
				return (
					<div>
						<Typography align="right" sx={{ mr: 1 }}>
							{+cell?.row?.original?.credit !== 0 ? cell?.row?.original?.credit : ''}
						</Typography>
					</div>
				);
			},
		},
	];
	const defaultVisibleColumn = useMemo(() => {
		// Return an array of column IDs that should be hidden (where isVisible is false)
		return checkColumnDesign.filter((column) => column.isVisible === false).map((column) => column.id);
	}, [checkColumnDesign]);
	const handleClose = () => {
		setShowModal(false);
	};

	return (
		<React.Fragment>
			<Dialog
				fullWidth={true}
				maxWidth={'lg'}
				open={showModal}
				keepMounted
				onClose={handleClose}
				aria-labelledby="draggable-dialog-title"
				sx={{ '& .MuiPaper-root': { borderRadius: '8px' } }}
			>
				<ViewEditModalHeader
					headerTitle="Journal Entry"
					// type={type}
					handleClose={handleClose}
					// icon={comptroller}
					// screenSize={screenSize}
					isScreenSize={false}
					// setScreenSize={setScreenSize}
					icon={<SolutionCatalogIcon color="#fff" width="20px" height="20px" />}
				/>

				<DialogContent sx={{ pb: { xs: 4, md: 7 } }}>
					<Spin spinning={propcessData?.length === 0} style={{ maxHeight: '100%', marginTop: '20px' }}>
						{propcessData?.length !== 0 && (
							<LeaseDataTable
								xlsxFileName={`${tableUpperLeftExtraInfo?.leaseId}_date`}
								firstColStrick={false}
								COLUMNS={checkColumnDesign || []}
								DATA={propcessData || []}
								pageSize={propcessData?.length}
								pagination={false}
								onClickHandler={() => {}}
								columnFilterSelector={true}
								tableUpperLeftExtraInfo={tableUpperLeftExtraInfo}
								defaultVisibleColumn={defaultVisibleColumn}
							></LeaseDataTable>
						)}
					</Spin>
				</DialogContent>
			</Dialog>
		</React.Fragment>
	);
};
export default LeaseRecordViewModal;
